import React from "react";
import FeaturedImage from "../FeaturedImage";

import Texture5 from "../../assets/images/icons/texture-5.svgr";
import Texture2 from "../../assets/images/icons/texture-2.svgr";
import Arrow from "../../assets/images/icons/arrow-forward.svgr";

function post(props) {
  const {
    post,
    postType,
    displayAuthor,
    displayExcerpt,
    displayDate,
    displayCategories,

    replaceSelected,
    theExcerpt,
  } = props;

  let categories;
  let categoryItems;
  let featuredImage;
  let author;
  let excerpt;
  let date;

  if (
    post.hasOwnProperty("_embedded") &&
    post._embedded.hasOwnProperty("wp:featuredmedia")
  ) {
    featuredImage = (
      <figure className="post-card__img-wrapper">
        <FeaturedImage
          imageSize={"eight29_post_thumb"}
          image={post._embedded["wp:featuredmedia"]}
          srcset={post.featured_image_srcset}
        ></FeaturedImage>
      </figure>
    );
  }

  if (
    post.hasOwnProperty("_embedded") &&
    post._embedded.hasOwnProperty("wp:term")
  ) {
    categories = post._embedded["wp:term"][0];
  }

  if (categories && displayCategories) {
    categoryItems = categories.map((category) => {
      const catName = category.name.replace('&amp;', '&');
      return (
        <button
          key={category.id}
          onClick={(e) => {
            e.preventDefault();
            replaceSelected(category.id, category.taxonomy);
          }}
        >
          {catName}
        </button>
      );
    });
  }

  if (post.author && displayAuthor) {
    author = <span className="author">By {post.author}</span>;
  }

  if (post.excerpt && displayExcerpt) {
    excerpt = (
      <div
        className="eight29-post-excerpt"
        dangerouslySetInnerHTML={{ __html: theExcerpt(post.excerpt.rendered) }}
      ></div>
    );
  }

  if (displayDate) {
    date = <time>{post.formatted_date}</time>;
  }

  return (
    <div>
      <article
        id={`${postType}-${post.id}`}
        className={`post-card ${!featuredImage && ` post-card--no-image`}`}
      >
        <a href={post.link} className="post-card__link">
          <div className="post-card__texture">
            {featuredImage ? <Texture5></Texture5> : <Texture2></Texture2>}
          </div>

          {featuredImage}

          <div className="eight29-post-body post-card__text-wrapper">
            <p className="eight29-post-categories overline">{categoryItems}</p>
            <h3
              className="post-card__title"
              dangerouslySetInnerHTML={{ __html: post.title.rendered }}
            ></h3>
            {displayDate || displayAuthor ? (
              <div className="eight29-post-detail">
                {date}
                {author}
              </div>
            ) : null}

            {featuredImage && (
              <p className="eight29-post-more post-card__read-more">
                Read more <Arrow></Arrow>
              </p>
            )}
          </div>
        </a>
      </article>
    </div>
  );
}

export default post;
